var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pattern-background',[_c('div',{staticClass:"login-wrapper"},[_c('login',{attrs:{"showLogo":"true","message":"👋 Create an account and follow the instructions to set up your first Retro"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }